import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../api/GenericPromises';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { Menuitem } from '../../../../interfaces/Security/menu';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';
import { usePermissions } from '../../../../hooks/usePermissions';
import { Box, Button, CircularProgress, Typography, Backdrop } from '@mui/material';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { ButtonLoading } from '../../../../theme/buttons';
import { DialogEntity } from '../../../../components/Dialogs/DialogEntity';
import { useCurrencies } from '../../../../hooks/useCurrencies';
import { useBase64 } from '../../../../hooks/useBase64';
import { AddNotificationNoAuthorizePayments } from './components/createNotification';
import { HeaderAuthorizationPayment } from './HeaderAuthorization/HeaderAuthorization';
import { TableAuthorizationPayment } from './Table/table';
import { PaymentDetail } from '../../../../interfaces/Purchases/Payments/payments';
import { useCompanyStore } from '../../../../store/AuthStore';
import { FilterTableRef } from '../../../../components/Filter';

interface MyTableCurrencyBanks {
  currency_id: number,
  currency_code: string,
  currency_description: string,
  balanceBankAccount: number,
  balanceAutorized: number,
  balanceFree: number,
  exchangeRate: number,
  active: boolean
}

export const TableAuthorizationPayments = () => {
  const [t] = useTranslation("global");
  const { GenericGetResource, GenericGetResourceGeneric, GenericPostResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const { GetOperatorToGetDivisa } = useCurrencies();
  const { companyState } = useCompanyStore();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [unauthorized, setUnauthorized] = useState(true);
  const [dialogPayment, setDialogPayment] = useState(false);
  const [clickedButtonGoBack, setClickedButtonGoBack] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingPost, setIsLoadingPost] = useState(false);
  const [selectedRows, setSelectedRows] = useState<GridRowsProp>([]);
  const [paymentsDetailsData, setPaymentsDetailsData] = useState<GridRowsProp>([]);
  const [totalPaymentsDetailsData, setTotalPaymentsDetailsData] = useState<GridRowsProp>([]);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [resourceAuthorizePayments, setResourceAuthorizePayments] = useState<Menuitem>();
  const [messageSnack, setMessageSnack] = useState("");
  const [spinnerBalance, setSpinnerBalance] = useState(false);
  const [companyBalance, setCompanyBalance] = useState({ balance: 0, currency_id: 0, currency_code: "" })
  const [dataCurrencyTable, setDataCurrencyTable] = useState<MyTableCurrencyBanks[]>([]);
  const [backDropLoading, setBackDropLoading] = useState(false);
  const [dialogAgreePayNegative, setDialogAgreePayNegative] = useState(false);
  const [openDialogAddNotification, setOpenDialogAddNotification] = useState(false);
  const { utf8ToBase64 } = useBase64();
  const { GetResourceByUrl } = usePermissions();
  const initFilter = '/authorizationpayments?filter=';
  const defaultFilter = [
    { idFilter: 1, column: "payment_name", operator: "=", value: "" },
    { idFilter: 2, column: "is_authorized", operator: "=", value: "False" },
  ];
  const [columnsAuthorizationPayments, setColumnsAuthorizationPayments] = useState<GridColDef<PaymentDetail>[]>([]);
  const refTableFilter = useRef<FilterTableRef>(null);

  const onAuthorizePayments = (isAgree: boolean = false) => {
    let myPaymentsDataToAuthorize = {
      data: selectedRows
        .filter(row => row.payment_detail_id && row.is_authorized === false)
        .map(row => row.payment_detail_id),
    };
    if (dataCurrencyTable.find((element) => element.balanceFree < 0) && !isAgree) {
      showSnackBar(t("authorizationpayments.info.no_balance_free"), "warning");
      setDialogAgreePayNegative(true);
      return;
    }
    if (myPaymentsDataToAuthorize.data.length > 0) {
      setIsLoadingPost(true);
      setBackDropLoading(true);
      GenericPostResource(`/authorizationpayments/isauthorized`, myPaymentsDataToAuthorize)
        .then((response) => {
          showSnackBar(t("authorizationpayments.info.authorized"), "success");
          refTableFilter.current?.applyFilter();
          let myAuthorizeData: PaymentDetail[] = response.data.result.data;
          const authorizedIds = new Set(myAuthorizeData.map(item => item.payment_detail_id));
          onApplyFilterAfterAuthorize(paymentsDetailsData.filter(item => !authorizedIds.has(item.payment_detail_id)));
          setTotalPaymentsDetailsData(prevData =>
            prevData.map((item: any) =>
              myPaymentsDataToAuthorize.data.includes(item.payment_detail_id)
                ? { ...item, is_authorized: true }
                : item
            )
          );
          setDialogPayment(false);
          setDialogAgreePayNegative(false);
          setClickedButtonGoBack((prev) => !prev);
        })
        .catch((error) => {
          showSnackBar(error.message, 'error');
        })
        .finally(() => {
          setIsLoadingPost(false);
          setBackDropLoading(false);
        });
    }
    else {
      showSnackBar(t("authorizationpayments.info.already-authorized"), "info");
    }
  }

  const GetTheAmountForSum = async (myRow: any) => {
    if (dataCurrencyTable.length > 0) {
      //BUscar en la tabla de currency de cuentas de banco si hay un banco con la cuenta bancaria
      let currencyEntry = dataCurrencyTable.find((currency) => currency.currency_code === myRow.related_currency_code && currency.active)
      if (!currencyEntry) {
        //Busca el por default que es el MXN
        currencyEntry = dataCurrencyTable.find((currency) => currency.currency_code === "MXN" && currency.active)
        if (!currencyEntry) {
          //Agarra el primero que encuentre
          currencyEntry = dataCurrencyTable.find((currency) => currency.active)
        }
      }
      if (currencyEntry && myRow.related_currency_code === currencyEntry.currency_code) {
        let amountSum = 0;
        if (myRow.current_payment_status_id === 1) {
          amountSum = myRow.amount_outstanding
          currencyEntry.balanceAutorized += amountSum;
          currencyEntry.balanceFree -= amountSum;
        }
      }
      else if (currencyEntry) {
        {
          let exchangeRate = dataCurrencyTable.find((element) => element.currency_code === myRow.related_currency_code)?.exchangeRate ?? 1;
          if (exchangeRate === 1) {
            exchangeRate = await dataCurrencyTable.find((element) => element.currency_code === currencyEntry?.currency_code)?.exchangeRate ?? 1;
          }
          let amountSum = 0;
          if (myRow.current_payment_status_id === 1) {
            let myOperation = await GetOperatorToGetDivisa(currencyEntry.currency_code, myRow.related_currency_code);
            // si es multiply:
            if (myOperation === "multiply") {
              amountSum = myRow.amount_outstanding * exchangeRate
            }
            // si es divide
            else if (myOperation === "divide") {
              amountSum = myRow.amount_outstanding / exchangeRate
            }
            currencyEntry.balanceAutorized += amountSum;
            currencyEntry.balanceFree -= amountSum;
          }
        }
      }
    }
  }

  const onApplyFilterAfterAuthorize = async (data: any) => {
    setSelectedRows([]);
    setPaymentsDetailsData([]);
    try {
      if (data && data.length && data.length > 0) {
        setPaymentsDetailsData(data);
      }
    } catch (error: any) {
      showSnackBar(`${error}`, "error");
    }
    finally {
      setIsLoadingData(false);
    }
  }

  useEffect(() => {
    const calculateBalance = async () => {
      try {
        //Setear en 0
        await dataCurrencyTable.map((element) => { element.balanceAutorized = 0; element.balanceFree = element.balanceBankAccount });
        //Sumar autorizadas
        for (const column of totalPaymentsDetailsData) {
          if (column.is_authorized) {
            await GetTheAmountForSum(column);
          }
        }

        //Sumar seleccionadas
        for (const column of selectedRows) {
          if (!column.is_authorized) {
            await GetTheAmountForSum(column);
          }
        }

        setBackDropLoading(false);
        setSpinnerBalance(false);
      } catch (error) {
        console.error("Error calculating balance:", error);
        setSpinnerBalance(false);
      }
    };
    if (companyBalance.currency_code.length && totalPaymentsDetailsData.length > 0) {
      setSpinnerBalance(true);
      calculateBalance();
    }
  }, [companyBalance, selectedRows, totalPaymentsDetailsData]);

  useEffect(() => {
    const loadInitData = async () => {
      document.title = `${companyState?.comercial_name} - ${t("authorizationpayments.title")}`;
      GetResourceByUrl(`/authorizationpayments`)
        .then((responsePermission) => {
          setResourceScreen(responsePermission);
        });

      if (companyState?.primary_bank_account && companyState.primary_bank_account > 0) {
        await GenericGetResource(`/bankaccounts/${companyState.primary_bank_account}`)
          .then((responseBank) => {
            let balanceCompany = {
              balance: responseBank.data.balance,
              currency_id: responseBank.data.currency_id,
              currency_code: responseBank.data.currency_code
            }
            setCompanyBalance(balanceCompany);
          });
      }
      else {
        showSnackBar(t("authorizationpayments.info.no_primary_bank"), "info");
      }
      setDataLoaded(true);

      GetResourceByUrl(`/authorizationpayments/isauthorized`)
        .then((responsePermission) => {
          setResourceAuthorizePayments(responsePermission);
        });
    }
    loadInitData();
  }, []);

  useEffect(() => { }, [backDropLoading]);

  return (
    <>
      {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}
      {unauthorized && !dataLoaded && <>
        <Spinner />
        <SnackbarComponent />
      </>}
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={backDropLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
      {resourceScreen?.read &&
        <Box display="flex" flexDirection="column">
          <Box
            sx={{
              minWidth: 300,
              marginBlock: 1,
              display: "flex",
              flexDirection: 'column',
              maxHeight: '100vh',
              width: "100%"
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                minHeight: '15vh',
                backgroundColor: 'white',
              }}
            >
              <Header size="no_title"
                child={
                  <HeaderAuthorizationPayment
                    resourceScreen={resourceScreen}
                    dataCurrencyTable={dataCurrencyTable}
                    setDataCurrencyTable={setDataCurrencyTable}
                    setBackDropLoading={setBackDropLoading}
                    setMessageSnack={setMessageSnack}
                    setUnauthorized={setUnauthorized}
                    showSnackBar={showSnackBar}
                    selectedRows={selectedRows}
                    resourceAuthorizePayments={resourceAuthorizePayments}
                    setDialogPayment={setDialogPayment}
                    setOpenDialogAddNotification={setOpenDialogAddNotification}
                    defaultFilter={defaultFilter}
                    initFilter={initFilter}
                    setIsLoadingData={setIsLoadingData}
                    setPaymentsDetailsData={setPaymentsDetailsData}
                    columnsAuthorizationPayments={columnsAuthorizationPayments}
                    onApplyFilter={onApplyFilterAfterAuthorize}
                    refTableFilter={refTableFilter}
                  />
                }
              />
            </Box>
            <Box
              sx={{
                padding: 1,
                marginBlock: 1,
                borderRadius: 1,
                maxHeight: '65vh',
                top: '20vh',
              }}>
              <TableAuthorizationPayment
                resourceScreen={resourceScreen}
                setSelectedRows={setSelectedRows}
                paymentsDetailsData={paymentsDetailsData}
                setTotalPaymentsDetailsData={setTotalPaymentsDetailsData}
                setMessageSnack={setMessageSnack}
                showSnackBar={showSnackBar}
                setUnauthorized={setUnauthorized}
                columnsAuthorizationPayments={columnsAuthorizationPayments}
                setColumnsAuthorizationPayments={setColumnsAuthorizationPayments}
                isLoadingData={isLoadingData}
              />
            </Box>
          </Box>
          <DialogEntity
            open={dialogPayment}
            setOpen={setDialogPayment}
            title={t("authorizationpayments.dialog.title")}
            content={
              <Box display={"flex"} flexDirection={"column"}>
                <Typography>{t("authorizationpayments.dialog.content")}</Typography>
                <Box display={"flex"} flexDirection={"row-reverse"} marginTop={2}>
                  <ButtonLoading
                    disabled={!resourceAuthorizePayments?.create}
                    isLoading={isLoadingPost}
                    onClick={() => onAuthorizePayments()}
                    className="d-flex align-self-end w-25"
                    variant="outlined"
                  >
                    {t("generic.buttons.accept")}
                  </ButtonLoading>
                  <Button variant='outlined' onClick={() => { setDialogPayment(false); setClickedButtonGoBack((prev) => !prev) }}>{t("generic.buttons.goback")}</Button>
                </Box>
              </Box>
            }
          />
          <DialogEntity
            open={dialogAgreePayNegative}
            setOpen={setDialogAgreePayNegative}
            title={t("authorizationpayments.dialog.title")}
            content={
              <Box display={"flex"} flexDirection={"column"}>
                <Typography>{t("authorizationpayments.dialog.content_pay_negative")}</Typography>
                <Box display={"flex"} flexDirection={"row-reverse"} marginTop={2}>
                  <ButtonLoading
                    disabled={!resourceAuthorizePayments?.create}
                    isLoading={isLoadingPost}
                    onClick={() => onAuthorizePayments(true)}
                    className="d-flex align-self-end w-25"
                    variant="outlined"
                  >
                    {t("generic.buttons.accept")}
                  </ButtonLoading>
                  <Button variant='outlined' onClick={() => { setDialogPayment(false); setDialogAgreePayNegative(false); setClickedButtonGoBack((prev) => !prev) }}>{t("generic.buttons.goback")}</Button>
                </Box>
              </Box>
            }
          />
          <DialogEntity
            content={
              <AddNotificationNoAuthorizePayments
                setOpenDialogAddNotification={setOpenDialogAddNotification}
                selectedRows={selectedRows}
                setTotalPaymentsDetailsData={setTotalPaymentsDetailsData}
                refTableFilter={refTableFilter}
              />
            }
            open={openDialogAddNotification}
            setOpen={setOpenDialogAddNotification}
            title={
              <Header title={t("notifications.title-view")} size="sm" />
            }
          />
          <SnackbarComponent />
        </Box>
      }
    </>
  )
}
